/* NEW WAY OF LOADING COMPONENTS
  Each view or components required with this pattern needs an extra static method called create
  This will take a parent DOM element and look for children matching the what is required for the
  view to initialise internally. This initialisation of the constructor will be performed in the module itself.
  This allows us to pass $('body') on page load, and a wrapper element for ajax loaded content.
========================================================================== */

'use strict';

import { getLogger } from 'loglevel';
import { checkRunSpeedPerformance } from '../utilities/performanceHelpers';
import * as featureFlags from '../utilities/featureFlags';

var _ = require('underscore'),
  config = require('./config'),
  mediator = require('./mediator');

const log = getLogger('components');

//Components will be stored in here and will be looped through to find matching element
//to initialise when new content is added.
const components = [];

export const loadComponents = function($parent) {
  log.debug('Loading components within', $parent);
  _.each(components, function(component) {
    if (component.create) {
      checkRunSpeedPerformance(
        'component',
        config.framesPerSecondMs[50],
        config.framesPerSecondMs[50],
        component.create,
        component
      )($parent);
    }
  });
};

mediator.on(config.events.ui.ajaxContentLoaded, loadComponents);

//this will eventually be globbed,
//allowing you to drop files into the components folder and have them just work.
//For now as we still have some refactoring to do around which components belong in here to
//follow this new pattern, we will just include them one by one.

components.push(require('./components/ProductDetailPdfDownload'));
components.push(require('./components/Share'));
components.push(require('./components/InputSearchView'));
components.push(require('./components/backButton'));
components.push(require('../components/Carousel/CarouselView'));
components.push(require('../components/Carousel/CounterCarouselView'));
components.push(require('../components/Carousel/ResponsiveCarouselView'));
components.push(require('./components/carousel/ImageSliderView'));
components.push(require('../components/Carousel/PromotedSlider'));
components.push(require('../components/Carousel/FixedItemCarouselView'));
components.push(require('./components/carousel/ExpandingCarouselView'));
components.push(require('./components/carousel/TabbedCarouselView'));
components.push(require('./components/CategoriesView'));

components.push(require('../components/DesignCenter/CreateProjectView'));
components.push(require('../components/DesignCenter/DeleteFromProjectView'));
components.push(require('../components/DesignCenter/DeleteProjectView'));
components.push(require('../components/DesignCenter/MyProjectsView'));
components.push(require('../components/DesignCenter/projectDetailsEnvisionTooltip'));
components.push(require('../components/DesignCenter/projectDetailsViewAllUsersModal'));
components.push(require('../components/DesignCenter/projectDetailsAddUsersModal'));
components.push(require('../components/DesignCenter/ChangeProjectNameControl'));
components.push(require('../components/DesignCenter/projectDetailsEnvisionButton'));

components.push(require('./components/LazyLoadView'));
components.push(require('./components/SearchDoublePlaceholder'));
components.push(require('./components/ImageOverlayView'));
components.push(require('./components/FilteredPageView'));
components.push(require('./components/Tooltip'));
components.push(require('./navigation/jumpTo'));
components.push(require('./components/YouTubePlayer'));

components.push(require('./components/NewsletterTabsView'));
components.push(require('../components/Newsletters/NewslettersView'));
components.push(require('./components/logoutHandler'));

if (featureFlags.AjaxLoadPageFooter.isEnabled()) {
  components.push(require('../components/Footer/Footer'));
}


// WEBPACK FOOTER //
// ./assets/js/components.js